var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "#F3F5FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6155 15.5C17.3999 15.5 18.8463 14.0449 18.8463 12.25C18.8463 10.4551 17.3999 9 15.6155 9C13.8312 9 12.3848 10.4551 12.3848 12.25C12.3848 14.0449 13.8312 15.5 15.6155 15.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3846 19.2143C18.3846 18.4451 19.0046 17.8214 19.7693 17.8214H19.857C19.2791 16.684 18.1175 15.9671 16.8477 15.9643H14.3831C12.5157 15.9669 11.0025 17.489 11 19.3675V21.5357C11 21.7922 11.2066 22 11.4615 22H19.7693C20.0242 22 20.2308 21.7922 20.2308 21.5357V20.6072H19.7693C19.0046 20.6072 18.3846 19.9836 18.3846 19.2143Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.f36e31d8f1a07a557af3c725c0f749dd.svg";
export { ForwardRef as ReactComponent };